import {publicFiles} from '../../api/api-endpoints'

const title = 'Текстовые материалы территориальной схемы';
const append = (menu,needToAppend) => {
  if(!('data' in needToAppend)) {
    return menu;
  }
  if(needToAppend.data.length === 0) {
    return menu;
  }
  const childs = needToAppend.data.map((item) =>({...item,href:publicFiles.file(item.id)}));
  menu.push({
    title,
    number: menu.length + 1,
    childs
  });
  //часть меню лежит в model.js ¯\_(ツ)_/¯
  //как это здорово!
  if (process.env.REGION === 'kursk') {
    menu.push({
      title: 'Описание форматов взаимодействия электронных сервисов',
      href: 'http://kursk-tko.etton.ru/storage/api.docx',
      number: menu.length + 1
    })
  }
  return menu;
};
export {
  append
}
